import React from 'react'

import {
  Span,
  Row,
} from 'components'

import { Caption } from './styles'

interface FakeCaptionProps {
  title: string
  color: string
}

const FakeCaption: React.FC<FakeCaptionProps> = ({
  title,
  color,
}) => {
  return (
    <Row alignItems="center">
      <Caption color={color} />
      <div style={{ width: 8 }} />
      <Span
        text={title}
        color="#0009"
        fontSize="0.8rem"
      />
    </Row>
  )
}

export default FakeCaption
